import React, { useEffect, useState } from "react";
import axios from "axios";
import "./RevisaoObjecoes.css";

function RevisaoObjecoes() {
  const [dados, setDados] = useState([]);
  const [leads, setLeads] = useState([]);
  const [objecoes, setObjecoes] = useState([]);
  const [usuarioTipo, setUsuarioTipo] = useState(""); // 'master' ou 'cliente'
  const [filters, setFilters] = useState({
    lead_id: "",
    data_inicio: "",
    data_fim: "",
    objecao: "",
  });

  useEffect(() => {
    fetchUsuarioTipo();
    fetchLeads();
    fetchObjecoes();
    fetchDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Obtém o tipo do usuário logado
  const fetchUsuarioTipo = async () => {
    try {
      const response = await axios.get("https://welaunchyou.com.br/crm-wly/getUserTipo.php", {
        withCredentials: true,
      });
      setUsuarioTipo(response.data.tipo_usuario);
    } catch (error) {
      console.error("Erro ao buscar tipo de usuário:", error);
    }
  };

  const fetchLeads = async () => {
    try {
      const response = await axios.get("https://welaunchyou.com.br/crm-wly/getLeads.php", {
        withCredentials: true,
      });
      setLeads(response.data);
    } catch (error) {
      console.error("Erro ao buscar leads:", error);
    }
  };

  const fetchObjecoes = async () => {
    try {
      const response = await axios.get("https://welaunchyou.com.br/crm-wly/getObjecoes.php", {
        withCredentials: true,
      });
      setObjecoes(response.data);
    } catch (error) {
      console.error("Erro ao buscar objeções:", error);
    }
  };

  const fetchDados = async () => {
    try {
      const queryString = new URLSearchParams(filters).toString();
      const response = await axios.get(
        `https://welaunchyou.com.br/crm-wly/revisaoObjecoes.php?${queryString}`,
        { withCredentials: true }
      );

      console.log("Dados recebidos:", response.data);
      setDados(response.data);
    } catch (error) {
      console.error("Erro ao buscar objeções:", error);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchDados();
  };

  return (
    <div className="listagem-objecoes">
      <h1>Revisão de Objeções</h1>

    <div className="container-revisao">
     

      {/* Filtros - Mostrar "Lead" apenas para usuários master */}
      <form className="filter-form" onSubmit={handleFilterSubmit}>
        {usuarioTipo === "master" && (
          <div className="form-group">
            <label>Lead:</label>
            <select name="lead_id" value={filters.lead_id} onChange={handleFilterChange}>
              <option value="">Todos</option>
              {leads.map((lead) => (
                <option key={lead.id} value={lead.id}>
                  {lead.nome}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group">
          <label>Data Início:</label>
          <input type="date" name="data_inicio" value={filters.data_inicio} onChange={handleFilterChange} />
        </div>

        <div className="form-group">
          <label>Data Fim:</label>
          <input type="date" name="data_fim" value={filters.data_fim} onChange={handleFilterChange} />
        </div>

        <div className="form-group">
          <label>Objeção:</label>
          <select name="objecao" value={filters.objecao} onChange={handleFilterChange}>
            <option value="">Todas</option>
            {objecoes.map((obj) => (
              <option key={obj.descricao} value={obj.descricao}>
                {obj.descricao}
              </option>
            ))}
          </select>
        </div>

        <button type="submit">Filtrar</button>
      </form>

      {/* Tabela de Objeções */}
      <table className="objecoes-table">
        <thead>
          <tr>
            <th>Nome do Lead</th>
            <th>Objeção</th>
            <th>Data</th>
            <th>WhatsApp</th>
          </tr>
        </thead>
        <tbody>
          {dados.length > 0 ? (
            dados.map((linha, index) => (
              <tr key={index}>
                <td>{linha.nome_lead}</td>
                <td>{linha.objecao}</td>
                <td>{new Date(linha.data).toLocaleDateString("pt-BR")}</td>
                <td>
                  <a className="whatsapp-link" href={`https://wa.me/${linha.telefone.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer">
                    {linha.telefone}
                    
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">Nenhuma objeção encontrada.</td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default RevisaoObjecoes;
